<template>
	<div class="cruiseOrder">
		<back-to></back-to>
		<section class="content">
			<section class="cruiseOrder_top">
				<span class="cruiseOrder_top_title">{{param.productName}}</span>
				<span class="cruiseOrder_top_content">
					<label for="">
						<p>
							<font>舱型</font>
							<font>{{param.proName}}</font>
						</p>
						<p>
							<font>出行日期</font>
							<font>{{param.departureDate | formatTime}}</font>
						</p>
						<p>
							<font>人数</font>
							<font>成人×{{param.number}}</font>
						</p>
					</label>
					<img :src="param.image" alt="">
				</span>
			</section>
			<section class="person_info">
				<h2>订单联系人</h2>
				<van-cell-group>
					<van-field v-model="input_contact_name" label="姓名" placeholder="请填写实际入住人姓名" />
					<van-field v-model="input_contact_people" label="电话" placeholder="请填写实际入住人电话" type="tel" />
				</van-cell-group>
			</section>
			<section class="person_info">
				<h2>订单备注</h2>
				<van-cell-group>
					<van-field v-model="remarksRemarks" placeholder="请输入情况需求，价格信息备注无效" />
				</van-cell-group>
			</section>
			<section class="person_info">
				<h2>出行人信息</h2>
				<div class="person_infoma">
					<span class="person_infoma-item" v-for="(item,index) in param.number" :key="index"
						@click="$router.push({path: '/editInfo',query:{'index':index}})">
						<label for="" class="left-ar">
							<img class="dex"
								src="https://sweetour-pic.obs.myhwclouds.com/sweetour-newPlaceOrder-image_03.png"
								alt="">
							<div class="left-ara" v-if="cruiseinfo[index]">
								<label for="">
									<p>{{cruiseinfo[index].name}}</p>
									<font>成人</font>
								</label>
								<p>身份证：{{cruiseinfo[index].cardId}}</p>
							</div>
							<div class="left-ara" v-else>
								<label for="">
									<p>游客{{index+1}}</p>
									<font>成人</font>
								</label>
							</div>
						</label>
						<img class="right-ar" src="../../assets/ico_ar.png" alt="">
					</span>
				</div>
			</section>
		</section>
		<!-- 底部 -->
		<section class="choiceBtn">
			<div class="choiceBtn-l">
				<p>价格:</p>
				<font>￥{{param.payMoney}}</font>
			</div>
			<div class="choiceBtn-r" @click="submit">提交订单</div>
		</section>
	</div>
</template>

<script>
	import {
		mapGetters
	} from 'vuex'
	import {
		Toast
	} from 'vant'
	import BackTo from "@/components/BackTo";
	import {
		formatTime
	} from '@/config/util'
	export default {
		name: 'swimOrder',
		components: {
			BackTo
		},
		data() {
			return {
				param: "",
				input_contact_name: "",
				input_contact_people: "",
				remarksRemarks: ""
			}
		},
		filters: {
			formatTime(time) {
				let date = new Date(time * 1000)
				return formatTime(date)
			}
		},
		created() {
			let param = JSON.parse(this.$route.query.orderParam);
			this.param = param
			console.log(param)
		},
		computed: {
			...mapGetters('account', ['cruiseinfo', 'userInfo'])
		},
		mounted() {

		},
		methods: {
			submit() {
				if (this.input_contact_name == '') {
					Toast("请输入正确的姓名")
					return
				}
				if (this.input_contact_people == '') {
					Toast("请输入正确的电话")
					return
				}
				// 计算房间数
				var roomNum = this.param.number / this.param.data.cabins[this.param.selectIndex].max_stay
				let jsonData = {
					"cabin": [{
						"adult_num": this.param.number, // 几个人
						"adult_price": this.param.payMoney, // 价钱
						"cabin_id": this.param.data.cabins[this.param.selectIndex].cabinId, // 舱型id   cabin_id
						"cabin_type": this.param.data.cabins[this.param.selectIndex].allow_spell == true ? 2 :
							1, // 整间是1 否则是2
						"full": this.param.data.cabins[this.param.selectIndex].allow_spell == true ? -1 :
						2, // 整间是2 否则是-1
						"max_stay": this.param.data.cabins[this.param.selectIndex].max_stay, // 舱型最大人数
						"min_stay": this.param.data.cabins[this.param.selectIndex].min_stay, // 舱型最小人数
						"name": this.param.data.cabins[this.param.selectIndex].cabinName, // cabinName舱型名称
						"room_num": this.param.data.cabins[this.param.selectIndex].allow_spell == true ? -1 :
							roomNum, // 整间是1 否则是-1
						"sku_price_id": this.param.data.cabins[this.param.selectIndex]
							.sku_price_id, // 舱型sku_price_id
					}],
					"channel_cn": "线下直客", // 不动
					"deliver": [], // 不动
					"end_at": 24, // 不动
					"guest": [],
					"insure": [], // 不动
					"number": this.param.number, // 人数
					"occupy_status": 3, // 不动
					"order_channel": 3, // 不动
					"otherfee": [], // 不动
					"payable": parseInt(this.param.payMoney), // 钱数
					"plan_id": this.param.data.plan_id, // planid
					"platform": 1, // 不动
					"price_type": 1, // 不动
					"product_id": parseInt(this.param.id), // 产品id
					"product_name": this.param.productName, // 产品name
					"replacesale": 364, // 不动
					"replacesale_cn": "韩辉", // 不动
					"tour_no": this.param.data.tour_no // 游轮名字
				}
				if (this.cruiseinfo.length > 0 && this.cruiseinfo) {
					jsonData.guest = this.cruiseinfo
					for (var i in this.cruiseinfo) {
						jsonData.guest[i].cabin_id = this.param.data.cabins[this.param.selectIndex].cabinId
						jsonData.guest[i].cabin_type = this.param.data.cabins[this.param.selectIndex]
							.allow_spell == true ? 2 : 1 // 整间是1 否则是2
						jsonData.guest[i].enrollID = this.param.data.cabins[this.param.selectIndex]
							.sku_price_id // 舱型sku_price_id
						jsonData.guest[i].enrollName = this.param.data.cabins[this.param.selectIndex]
							.cabinName // cabinName舱型名称
						jsonData.guest[i].enroll_type = 1 // 不动
						jsonData.guest[i].id_card = this.cruiseinfo[i].cardId //身份证
						jsonData.guest[i].name = this.cruiseinfo[i].name //信息名
						jsonData.guest[i].passport = this.cruiseinfo[i].passport // 护照
						jsonData.guest[i].refund_status = 4
						jsonData.guest[i].sex = this.cruiseinfo[i].sexid // 性别
						jsonData.guest[i].sku_price_id = this.param.data.cabins[this.param.selectIndex]
							.sku_price_id // 舱型sku_price_id
						jsonData.guest[i].tel = this.cruiseinfo[i].phone // 信息电话
					}
				} else {
					jsonData.guest = []
				}
				this.$_posts(
					this.$connectHttpSweetApi + '/linerapi/v1/order/order/checkdirectorder', jsonData
				).then(res => {
					Toast(res.message)
					this.flag = res.data
					this.callMessage = res.message

				})
				if (this.flag) {
					let obj = {
						Name: this.input_contact_name,
						Tel: this.input_contact_people,
						Mark: this.remarksRemarks,
					}
					let paramsOrderinsert = {
						"object": {
							"claim_id": 1147, //固定
							"claim_orgid": 621, //固定
							"claim_topid": 540, //固定
							"claim_skcomp": 540, //固定
							"number": parseInt(this.param.number),
							"productType": 4, //固定
							"userID": 1000, //固定
							"occupyStatus": 3, //固定
							"remark": this.remarksRemarks,
							"teamID": parseInt(this.param.id), //productId 117
							"platform": 5, //固定
							"planID": this.param.data.plan_id,
							"orgID": 518, //固定
							"payable": parseInt(this.param.payMoney),
							"settlementType": 0, //固定
							"contact": JSON.stringify(obj),
							"favourable": [],
							"guests": []
						}
					}
					if (this.cruiseinfo.length > 0 && this.cruiseinfo) {
						paramsOrderinsert.object.guest = this.cruiseinfo
						for (var i = 0; i < paramsOrderinsert.object.guest.length; i++) {
							paramsOrderinsert.object.guest[i].enrollID = this.param.data.cabins[this.param.selectIndex]
								.sku_price_id // 舱型sku_price_id
							paramsOrderinsert.object.guest[i].singlePrice = this.param.data.cabins[this.param.selectIndex]
								.price // 钱数
							paramsOrderinsert.object.guest[i].mobile = this.cruiseinfo[i].phone // 电话
							paramsOrderinsert.object.guest[i].enrollName = this.param.data.cabins[this.param.selectIndex]
								.cabinName // 舱型名
							paramsOrderinsert.object.guest[i].cnName = this.cruiseinfo[i].name // 用户名
						}
					} else {
						paramsOrderinsert.object.guest = []
					}

					var sub = {}
					var arrboj = []

					for (var i in paramsOrderinsert.object.guest) {
						sub = {
							enrollID: 0,
							singlePrice: 0,
							mobile: "",
							enrollName: "",
							cnName: ""
						}
						arrboj.push(sub)
					}

					for (var i in paramsOrderinsert.object.guest) {
						arrboj[i].enrollID = paramsOrderinsert.object.guest[i].enrollID
						arrboj[i].singlePrice = paramsOrderinsert.object.guest[i].singlePrice
						arrboj[i].mobile = paramsOrderinsert.object.guest[i].mobile
						arrboj[i].enrollName = paramsOrderinsert.object.guest[i].enrollName
						arrboj[i].cnName = paramsOrderinsert.object.guest[i].cnName
					}

					paramsOrderinsert.object.guest = arrboj
					this.$_posts(
						this.$connectHttpDayun + '/order/fenxiao/api/orderinsert', paramsOrderinsert
					).then(res => {
						this.details = JSON.parse(res.result.details)
					})
					// 第三个接口

					let paramsAdddirectorder = {
						cabin: [{
							adult_num: this.param.number, // 几个人
							adult_price: this.param.data.cabins[this.param.selectIndex].price, // 价钱,
							cabin_id: this.param.data.cabins[this.param.selectIndex]
								.cabinId, // 舱型id   cabin_id
							cabin_type: this.param.data.cabins[this.param.selectIndex].allow_spell == true ?
								2 : 1, // 整间是1 否则是2
							full: this.param.data.cabins[this.param.selectIndex].allow_spell == true ? -1 :
							2, // 整间是2 否则是-1
							max_stay: this.param.data.cabins[this.param.selectIndex].max_stay, // 舱型最大人数
							min_stay: this.param.data.cabins[this.param.selectIndex].min_stay, // 舱型最小人数
							name: this.param.data.cabins[this.param.selectIndex].cabinName, // cabinName舱型名称
							room_num: this.param.data.cabins[this.param.selectIndex].allow_spell == true ? -1 :
								b, // 整间是1 否则是-1
							sku_price_id: this.param.data.cabins[this.param.selectIndex].sku_price_id, //舱型
						}],
						channel_cn: "线下直客", // 不动
						contact: [{
							name: this.input_contact_name, //联系人姓名
							tel: this.input_contact_people, //联系人姓电话
						}],
						create_uid: 726, //应该不动
						deliver: [], //不动
						end_at: 24, //不动
						insure: [], // 不动
						mark: this.remarksRemarks, //备注把
						number: parseInt(this.param.number), // 人数
						occupy_status: 3, //不动
						order_channel: 3, // 不动
						order_code: this.details.OrderCode, // 第二个接口的OrderCode
						org_id: 567, // 应该不动
						otherfee: [], // 不动
						payable: parseInt(this.param.payMoney), // 总价把
						plan_id: this.param.data.plan_id, //planid
						platform: 1, // 不动
						price_type: 1, //不动 直客价格
						product_id: parseInt(this.param.id), //    产品id  117
						product_name: this.param.productName, // 产品名称
						repayment_at: "2022-05-11T02:08:41.090Z",
						replacesale: 364, // 不动
						replacesale_cn: "韩辉", //不动
						third_order_id: Number(this.details.OrderID), // 第二个接口的OrderID
						tour_no: this.param.data.tour_no, // 游轮名称
						guest: [],
					}

					if (this.cruiseinfo.length > 0 && this.cruiseinfo) {
						paramsAdddirectorder.guest = this.cruiseinfo
						for (var i in this.cruiseinfo) {
							paramsAdddirectorder.guest[i].cabin_id = this.param.data.cabins[this.param.selectIndex].cabinId
							paramsAdddirectorder.guest[i].cabin_type = this.param.data.cabins[this.param.selectIndex]
								.allow_spell == true ? 2 :
								1 // 整间是1 否则是2
							paramsAdddirectorder.guest[i].sku_price_id = this.param.data.cabins[this.param.selectIndex]
								.sku_price_id // 舱型sku_price_id
							paramsAdddirectorder.guest[i].enrollName = this.param.data.cabins[this.param.selectIndex]
								.cabinName // cabinName舱型名称
							paramsAdddirectorder.guest[i].enroll_type = 1 // 不动
							paramsAdddirectorder.guest[i].id_card = this.cruiseinfo[i].cardId //身份证
							paramsAdddirectorder.guest[i].name = this.cruiseinfo[i].name //信息名
							paramsAdddirectorder.guest[i].passport = this.cruiseinfo[i].passport // 护照
							paramsAdddirectorder.guest[i].refund_status = 4
							paramsAdddirectorder.guest[i].sex = this.cruiseinfo[i].sexid // 性别
							paramsAdddirectorder.guest[i].enrollID = this.param.data.cabins[this.param.selectIndex]
								.sku_price_id // 舱型sku_price_id
							paramsAdddirectorder.guest[i].tel = this.cruiseinfo[i].phone // 信息电话
						}
					} else {
						paramsAdddirectorder.guest = []
					}
					this.$_posts(
						this.$connectHttpSweetApi + '/linerapi/v1/order/order/adddirectorder', paramsAdddirectorder
					).then(res => {
						this.order_code = res.data.order_code
					})
					// 第四个下单
					var dataFor = {
						"orderCode": this.order_code,
						"userId": this.userInfo.userId,
						"orgId": this.$organizationId
					}
					this.$_post(
						this.$domainUrl + '/ShipApp/AddUserOrder', dataFor
					).then(res => {
						if (res.success) {
							localStorage.removeItem("cruiseinfo")
							this.$router.push({
								path: '/cruiseOrderDetail',
								query: {}
							})
						} else {
							Toast(res.msg)
						}
					})
				} else {
					Toast(this.callMessage)
				}
			}
		},
		beforeCreate() {
			document.querySelector('body').setAttribute('style', 'background-color:#f2f2f2')
		}
	}
</script>

<style scoped>
	.content {
		width: 100%;
		padding: 0 20px;
		box-sizing: border-box;
	}

	.cruiseOrder_top {
		width: 100%;
		height: 320px;
		background: #FFFFFF;
		border-radius: 16px;
		margin-top: 30px;
		display: flex;
		flex-direction: column;
		padding: 0 30px;
		box-sizing: border-box;
	}

	.cruiseOrder_top img {
		width: 173px;
		height: 173px;
		border-radius: 10px;
	}

	.cruiseOrder_top_title {
		width: 100%;
		height: 80px;
		line-height: 80px;
		font-size: 36px;
		display: flex;
		font-weight: bold;
		color: #36393E;
		border-bottom: 1px solid #EEEEEE;
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
	}

	.cruiseOrder_top_content {
		display: flex;
		align-items: center;
		justify-content: space-between;
		height: 240px;
		width: 100%;
	}

	.cruiseOrder_top_content label {
		display: flex;
		flex-direction: column;
		height: 173px;
		justify-content: space-between;
	}

	.cruiseOrder_top_content p {
		font-size: 28px;
		color: #999999;
		line-height: 48px;
	}

	.cruiseOrder_top_content font:first-child {
		width: 120px;
		display: inline-block;
	}

	.cruiseOrder_top_content font:last-child {
		margin-left: 36px;
		color: #36393E;
	}

	.person_info {
		width: 100%;
		background: #FFFFFF;
		border-radius: 16px;
		margin-top: 30px;
		padding: 30px;
		box-sizing: border-box;
	}

	.person_info h2 {
		font-size: 32px;
		color: #36393E;
		padding-bottom: 20px;
	}

	.van-cell {
		padding-left: 0 !important;
		padding-right: 0 !important;
	}

	.van-cell::after {
		right: 0;
		left: 0;
		border: 0;
	}

	.van-hairline--top-bottom::after {
		border: 0;
	}

	.dex {
		width: 32px;
		height: 32px;
	}

	.person_infoma {
		width: 100%;
		background: #F8F8F8;
		border-radius: 12px;
		display: flex;
		flex-direction: column;
	}

	.right-ar {
		width: 12px;
		height: 22px;
	}

	.person_infoma-item {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 30px 20px;
		box-sizing: border-box;
	}

	.left-ar {
		display: flex;
		align-items: center;
	}

	.left-ara {
		padding-left: 30px;
	}

	.left-ara label {
		display: flex;
		align-items: center;
	}

	.left-ara p {
		font-size: 24px;
		color: #999999;
		padding-top: 14px;
	}

	.left-ara label p {
		font-size: 28px;
		color: #333333;
		margin-right: 16px;
		padding: 0;
	}

	.left-ara label font {
		width: 76px;
		height: 36px;
		border-radius: 3px;
		border: 2px solid #FF7A09;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 24px;
		color: #FF7A09;
	}

	.choiceBtn {
		position: fixed;
		bottom: 0;
		left: 0;
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
		height: 96px;
		border-top: 1px solid #e5e4e3;
		background-color: #fff;
	}

	.choiceBtn div {
		height: 96px;
		display: flex;
		align-items: center;
	}

	.choiceBtn-r {
		width: 286px;
		background: #ff6d00;
		font-size: 36px;
		color: #fff;
		border: 0;
		justify-content: center;
	}

	.choiceBtn-l {
		color: #ff6d00;
		font-size: 48px;
		display: inline-block;
		padding-left: 28px;
		box-sizing: border-box;
	}

	.choiceBtn-l p {
		font-size: 28px;
		color: #333;
		margin-top: 12px;
		padding-right: 7px;
	}
</style>
